// app/javascript/controllers/login_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["deviceToken"]

  connect() {
    this.element.addEventListener("submit", () => {
      const token = localStorage.getItem("device_token")
      if (token && this.deviceTokenTarget) {
        this.deviceTokenTarget.value = token
      }
    })
  }
}
